import React, { useState, useEffect } from 'react';
import { Button, Divider, Form, Space, Table, Input, message } from 'antd';
import BannerLocationService from '../services/BannerLocationService';

import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import Dialog from '../components/dialog/Dialog';
import { values } from 'lodash';
const CreateBannerLocation = () => {
	const [show, setShow] = useState(false);
	const [bannerLocations, setBannerLocations] = useState();
	const [dataSource, setData] = useState();
	const [tableData, setTable] = useState();
	const [rePop, setRePop] = useState(false);
	const [update, setUpdate] = useState(false);
	const [updateId, setUpdateId] = useState();

	useEffect(() => {
		BannerLocationService.getBannerLocation()
			.then((data) => setBannerLocations(data.data))
			.catch((err) => message.error('failed'));
	}, [rePop]);

	useEffect(() => {
		if (bannerLocations) {
			const dataArray = [];

			for (const key in bannerLocations) {
				dataArray.push({ name: bannerLocations[key].name, _id: bannerLocations[key]._id });
			}

			setData(dataArray);
		}
	}, [bannerLocations]);

	const columns = [
		{
			title: 'Banner Location Name',
			dataIndex: 'name',
			key: 'bannerLocationName',
		},
		{
			title: 'Available Actions',
			key: 'action',
			render: function action(text, record) {
				return (
					<Space size={'middle'}>
						<EditOutlined
							onClick={() => {
								setUpdate(true);
								setUpdateId(record?._id);
							}}
						/>
						<DeleteOutlined
							onClick={() => {
								BannerLocationService.delete(record?._id)
									.then(() => message.success(' Deleted'))
									.catch(() => message.error('Deleting Failed'));
								setRePop(!rePop);
							}}
						/>
					</Space>
				);
			},
		},
	];

	const createBanner = (value) => {
		setShow(false);
		const data = { name: value.bannerLocationName };

		BannerLocationService.add(data)
			.then(() => message.success(' Created'))
			.catch(() => message.error('Create Location Failed'));
		setRePop(!rePop);
	};
	const updateBanner = (value) => {
		setUpdate(false);

		const data = { name: value.bannerLocationName };

		BannerLocationService.update(updateId, data)
			.then(() => message.success(' Updated'))
			.catch(() => message.error('Updating Failed'));
		setRePop(!rePop);
	};

	return (
		<div>
			<Button onClick={() => setShow(!show)}>Create New Banner Location</Button>

			<Divider />

			{bannerLocations && <Table dataSource={bannerLocations} columns={columns} rowKey="BannerTypeName" />}

			<Dialog visible={show} title={'Create Banner Location'} onCancel={() => setShow(false)}>
				<Form onFinish={createBanner}>
					<Form.Item name="bannerLocationName">
						<Input placeholder="Enter Banner Location Name"></Input>
					</Form.Item>

					<Form.Item>
						<Button type="primary" htmlType="submit">
							Add
						</Button>
					</Form.Item>
				</Form>
			</Dialog>
			<Dialog visible={update} title={'Update Banner Location'} onCancel={() => setUpdate(false)}>
				<Form onFinish={updateBanner}>
					<Form.Item name="bannerLocationName">
						<Input placeholder="Enter Banner Location Name"></Input>
					</Form.Item>

					<Form.Item>
						<Button type="primary" htmlType="submit">
							Add
						</Button>
					</Form.Item>
				</Form>
			</Dialog>
		</div>
	);
};

export default CreateBannerLocation;
